import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'clsx';
import { Dialog as HeadlessUiDialog } from '@headlessui/react';
import { AnimatePresence, m as motion } from 'framer-motion';
import { backdropStyles, containerStyles } from './DialogFactory.css';
const backdropAnimationVariants = {
    narrow: {
        enter: { opacity: 1, transition: { duration: 0.3 } },
        exit: { opacity: 0, transition: { duration: 0.2, when: 'afterChildren' } },
    },
    wide: {
        enter: { opacity: 1, transition: { duration: 0.3 } },
        exit: { opacity: 0, transition: { duration: 0.2 } },
    },
};
const containerAnimationVariants = {
    narrow: {
        enter: { y: '-100%', transition: { type: 'spring', stiffness: 200, damping: 24 } },
        exit: { y: 0, transition: { duration: 0.3 } },
    },
    wide: {
        enter: { y: 0, transition: { type: 'spring', stiffness: 200, damping: 24 } },
        exit: { y: '10%', transition: { duration: 0.3 } },
    },
};
export const DialogFactory = ({ children, className, initialFocusRef, isOpen, onDismiss, variant = 'narrow', }) => {
    return (_jsx(AnimatePresence, { initial: false, children: isOpen && (_jsx(HeadlessUiDialog, { initialFocus: initialFocusRef, onClose: onDismiss !== null && onDismiss !== void 0 ? onDismiss : function () {
                return null;
            }, open: isOpen, static: true, children: _jsx(motion.div, { animate: "enter", className: backdropStyles, "data-testid": "overlay-backdrop", exit: "exit", initial: "exit", variants: backdropAnimationVariants[variant], children: _jsx(HeadlessUiDialog.Panel, { as: motion.div, className: cx(containerStyles, className), variants: containerAnimationVariants[variant], children: children }) }) })) }));
};
